import {
    server
} from "@/api";


export const admin = {
    overview: async (params) => {
        return await server().get('api/dashboard/admin/overview', { params })
    },
    stats: async (params = {}) => {
        return await server().get('api/dashboard/admin/stats', { params })
    },
    viewAnalytics: async (params = {}) => {
        return await server().get('api/dashboard/admin/view-analytics', { params })
    },
}

export default {
    admin
}